import { render, staticRenderFns } from "./PortfolioGallery.vue?vue&type=template&id=59cba8ba&scoped=true"
import script from "./PortfolioGallery.vue?vue&type=script&lang=js"
export * from "./PortfolioGallery.vue?vue&type=script&lang=js"
import style0 from "./PortfolioGallery.vue?vue&type=style&index=0&id=59cba8ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cba8ba",
  null
  
)

export default component.exports